export const Application = {
  version: '1.0.0',
}
